export default () => {
	return sessionStorage.getItem("chatToken") ?? '';
}
